import { createFilePropertyValidator } from './createFilePropertyValidator';
import type { FileValidationResult } from './types';

export const createMimeTypeValidator = (allowedMimeTypes: Set<string>) =>
  createFilePropertyValidator({
    property: 'type',
    validator: ({ propertyValue }): FileValidationResult => {
      if (!allowedMimeTypes.has(propertyValue)) {
        return { valid: false, errorType: 'mimeType', mimeType: propertyValue };
      }
      return { valid: true };
    },
  });

export const createSizeValidator = (maxFileSize: number) =>
  createFilePropertyValidator({
    property: 'size',
    validator: ({ propertyValue }): FileValidationResult => {
      if (propertyValue > maxFileSize) {
        return { valid: false, errorType: 'size', size: propertyValue };
      }
      return { valid: true };
    },
  });
